import { endPoints } from "@/constants";
import * as apiService from "./apiService";

export async function getMatches(requestPayload) {
  return await apiService.apiCall(endPoints.GET_MATCHES, "GET", requestPayload);
}

// Whether this user's AI matches are still being built after onboarding.
// One answer for every surface that can lead to a property, so the Feed
// banner, the Property Selector and the tables cannot disagree.
export async function getAiSyncStatus() {
  return await apiService.apiCall(endPoints.GET_AI_SYNC_STATUS, "GET", {});
}
